import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga'

import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';


import de from 'react-intl/locale-data/de';
import en from 'react-intl/locale-data/en';
import {addLocaleData} from 'react-intl';

addLocaleData([...de, ...en]);

ReactGA.initialize('UA-141366097-4');
ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
